import '.d{display:flex;}.ssr-plugin'
import '.a4{align-items:stretch;}.ssr-plugin'
import '.z{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.di{background:var(--palette-white);}.ssr-plugin'
import '.ah{flex-grow:1;}.ssr-plugin'
import '.y{align-items:center;}.ssr-plugin'
import '.ai{max-width:77.5rem;}.ssr-plugin'
import '.ff{justify-content:stretch;}.ssr-plugin'
import '.br{position:sticky;}.ssr-plugin'
import '.bs{top:0px;}.ssr-plugin'
import '.bt{z-index:10;}.ssr-plugin'
import '.fg{padding-block:1rem;}.ssr-plugin'
import '.fh{height:3rem;}.ssr-plugin'
import '.bg{justify-content:space-between;}.ssr-plugin'
import '.bi{flex-wrap:wrap;}.ssr-plugin'
import '.fi{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.en{margin-top:2rem;}.ssr-plugin'
import '.hh{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="d a4 z e di"
      >
        <div className="ah d y z e"
        >
          <div className="ai d e ff br bs bt"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="fg fh d bg y bi"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="fi d e a4 en hh ai"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%', // 8rem is padding + navbar height
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
